import React, { useContext } from 'react';
import ModalItem from '../ModalItem/ModalItem';
import Container from '@material-ui/core/Container';
import IsMobileContext from '../../../common/IsMobileContext';
import '../common.scss';
import './for-companies.scss';
import { Trans, useTranslation } from 'react-i18next';
import section1 from './section1.svg';
import section2 from './section2.svg';
import section3 from './section3.svg';
import YellowButton from '../YellowButton';

const mobileWidth = 256;
const desktopWidth = 412;

function ForCompanies() {
  const { t: translation } = useTranslation();
  const t = (str, options) => translation(`forCompanies.${str}`, options);
  const isMobileDesign = useContext(IsMobileContext);
  const width = isMobileDesign ? mobileWidth : desktopWidth;
  const height = width + 1 - 1;

  return (
    <>
      <ModalItem>
        <>
          <Container className="for-companies-container">
            <header>
              {isMobileDesign
                ? <h2>{t('h1')}</h2>
                : <h1>{t('h1')}</h1>
              }
            </header>
            <div className="content">
              <section className="s1">
                <p className="p">
                  {t('s1.p1')}
                </p>
                <div className="p">
                  <ul className="marked-list">
                    {t('s1.p2', { returnObjects: true }).map((i, idx) => {
                      return <li key={idx}>{i}</li>;
                    })}
                  </ul>
                </div>
                <p className="p mobile-link">
                  <a href="http://promo.likengo.ru/tasks-request">
                    {t('s1.p3')}
                  </a>
                </p>
                <div className="img">
                  <img width={width} height={height} src={section1} alt={t('h1')} />
                </div>
              </section>
              <section className="s2">
                <h3>{t('s2.h')}</h3>
                <div className="p">
                  <ul className="ul-img">
                    <li>
                      <div className="li-img-cnt">
                        <div className="ul-title">{t('s2.li1.title')}</div>
                        <span>
                          <Trans i18nKey="forCompanies.s2.li1.text">
                            %<strong /><a href="mailto:tasks@likengo.ru"> </a>%
                          </Trans>
                        </span>
                      </div>
                    </li>
                    <li>
                      <div className="li-img-cnt">
                        <div className="ul-title">{t('s2.li2.title')}</div>
                        <span>{t('s2.li2.text')}</span>
                      </div>
                    </li>
                    <li>
                      <div className="li-img-cnt">
                        <div className="ul-title">{t('s2.li3.title')}</div>
                        <span>{t('s2.li3.text')}</span>
                      </div>
                    </li>
                  </ul>
                </div>
                <div className="img">
                  <img width={width} height={height} src={section2} alt={t('s2.h')} />
                </div>
              </section>
              <section className="s3">
                <h3>{t('s3.h')}</h3>
                <div className="p">
                  <strong>{t('s3.p1')}</strong>
                  <ul className="marked-list">
                    {t('s3.ul1', { returnObjects: true }).map((i, idx) => {
                      return <li key={idx}>{i}</li>;
                    })}
                  </ul>
                </div>
                <div className="p">
                  <strong>{t('s3.p2')}</strong>
                  <ul className="marked-list">
                    {t('s3.ul2', { returnObjects: true }).map((i, idx) => {
                      return <li key={idx}>{i}</li>;
                    })}
                  </ul>
                </div>
                <div className="img">
                  <img width={width} height={height} src={section3} alt={t('s3.h')} />
                </div>
              </section>
              <section className="s4">
                <h3>{t('s4.h')}</h3>
                <div className="p">
                  <ul className="ul-img">
                    <li>
                      <div className="li-img-cnt">
                        <div className="ul-title">{t('s4.li1.title')}</div>
                        <span>{t('s4.li1.text')}</span>
                      </div>
                    </li>
                    <li>
                      <div className="li-img-cnt">
                        <div className="ul-title">{t('s4.li2.title')}</div>
                        <span>{t('s4.li2.text')}</span>
                      </div>
                    </li>
                    <li>
                      <div className="li-img-cnt">
                        <div className="ul-title">{t('s4.li3.title')}</div>
                        <span>{t('s4.li3.text')}</span>
                      </div>
                    </li>
                    <li>
                      <div className="li-img-cnt">
                        <div className="ul-title">{t('s4.li4.title')}</div>
                        <span>{t('s4.li4.text')}</span>
                      </div>
                    </li>
                  </ul>
                </div>
              </section>
              <footer>
                <h3>{t('footer.h')}</h3>
                <div className="footer-btn">
                  <form action="http://promo.likengo.ru/tasks-request">
                    <YellowButton title={t('footer.btn')} hidden={false} type="submit" />
                  </form>
                </div>
                <p className="p">
                  <Trans i18nKey="forCompanies.footer.p">
                    %<a href="mailto:tasks@likengo.ru"> </a>%
                  </Trans>
                </p>
              </footer>
            </div>
          </Container>
        </>
      </ModalItem>
    </>
  );
}

export default ForCompanies;
